import React from "react"
import {
  searchBox,
  searchButton,
  searchWrapper,
  responsiveButton,
} from "./search-box.module.css"
import { FaSearch } from "react-icons/fa"
import { navigate } from "gatsby"

const SearchBox = () => {
  const handleResponsiveButtonClick = () => {
    navigate("/zoeken")
  }
  return (
    <div className={searchWrapper}>
      <form action="/zoeken">
        <input
          name="q"
          aria-label="Stel een vraag"
          className={searchBox}
          placeholder="Stel een vraag"
        />
        <button
          className={searchButton}
          aria-label="Verstuur je zoekopdracht"
          type="submit"
        >
          <FaSearch />
        </button>
      </form>
      <div className={responsiveButton} onClick={handleResponsiveButtonClick}>
        <FaSearch />
      </div>
    </div>
  )
}

export default SearchBox
